module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('navbar', {
    attrs: {
      "back": "",
      "fixed": "",
      "bg": ""
    }
  }, [_c('span', {
    slot: "title"
  }, [_vm._v("贷款顾问")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.typeList.length > 0),
      expression: "typeList.length > 0"
    }],
    staticClass: "loantype",
    class: {
      noTop: _vm.isWechat
    }
  }, [_c('typebar', {
    attrs: {
      "type-list": _vm.typeList,
      "select-type-index": _vm.selectTypeIndex,
      "active-color": '#fffefe',
      "color": '#dae4ee'
    },
    on: {
      "click-handler": _vm.clickHandler
    }
  })], 1), _vm._v(" "), _c('div', {
    ref: "pageContent",
    staticClass: "page-content",
    class: {
      contentTop: !_vm.isWechat
    },
    style: ({
      top: _vm.typeList.length > 0 ? '0.88rem' : '0rem'
    })
  }, [_c('scroller', {
    ref: "scroller",
    attrs: {
      "on-infinite": _vm.loadMore
    }
  }, [_c('ul', {
    staticClass: "consultant-wrapper"
  }, _vm._l((_vm.counselorList), function(item, index) {
    return _c('router-link', {
      key: index,
      staticClass: "list-item clearfix",
      attrs: {
        "tag": "li",
        "to": ("/consultant/articlelist/" + (item.uid))
      }
    }, [_c('div', {
      staticClass: "consultant-head"
    }, [_c('img', {
      attrs: {
        "src": item.logoUrl,
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "consultant-desc"
    }, [_c('h3', [_c('span', {
      staticClass: "consultant-name"
    }, [_vm._v(_vm._s(item.name))]), _c('span', {
      staticClass: "consultant-job"
    }, [_vm._v(_vm._s(item.profession))])]), _vm._v(" "), _c('p', {
      staticClass: "skilled"
    }, [_vm._v(_vm._s([].concat(item.skills).join(' | ')))]), _vm._v(" "), _c('div', {
      staticClass: "line"
    }), _vm._v(" "), _c('div', {
      staticClass: "consult-contact"
    }, [_c('div', {
      staticClass: "contact-item"
    }, [_c('span', {
      staticClass: "iconfont"
    }, [_vm._v("")]), _c('span', {
      staticClass: "phone"
    }, [_vm._v(_vm._s(item.phone))])]), _vm._v(" "), _c('div', {
      staticClass: "contact-item"
    }, [_c('span', {
      staticClass: "iconfont"
    }, [_vm._v("")]), _c('span', {
      staticClass: "wechat"
    }, [_vm._v(_vm._s(item.wechat))])]), _vm._v(" "), _c('div', {
      staticClass: "contact-item",
      staticStyle: {
        "margin-top": "1px"
      }
    }, [_c('span', {
      staticClass: "iconfont"
    }, [_vm._v("")]), _c('span', {
      staticClass: "qq"
    }, [_vm._v(_vm._s(item.qq))])])])])])
  }))])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-70bf5754!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/consultant/consultant.vue
// module id = 365
// module chunks = 1